import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, TextInput } from 'advenio-components'
import { Form as OriginalForm } from 'formsy-react'
import PropTypes from 'prop-types'

const ReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 80%;
  margin-bottom: 10px;

  @media (max-width: 763px) {
    margin-bottom: 300px;
  }
`
const Form = styled(OriginalForm)`
  width: 100%;
`

class Report extends Component {
  state = {
    info: '',
  }

  onChange = (e) => {
    const { category, setExtraData } = this.props
    const params = {
      category_id: category,
      description: e.target.value,
    }

    this.setState({ info: e.target.value }, () => setExtraData(params))
  }

  onClick = () => this.props.goToView('kidsToSleep', this.props.view, '')

  render() {
    return (
      <ReportContainer>
        <Form>
          <TextInput
            textarea
            label="Comentarios"
            name="Report"
            onChangeCallback={this.onChange}
          />
        </Form>
        {this.props.isGroupActivity ?
          <Button
            primary
            style={{ marginTop: '40px', width: '150px' }}
            onClick={this.onClick}
          >
            Agregar alumnos
          </Button> :
          ''
        }
      </ReportContainer>
    )
  }
}

Report.propTypes = {
  /** The ID of the activity type to be registered */
  category: PropTypes.number,
  /** Flag marking whether the activity being registered is for a group of students */
  isGroupActivity: PropTypes.bool,
  /** The current view */
  view: PropTypes.string,

  /** Callback function to navigate to the specified view */
  goToView: PropTypes.func.isRequired,
  /** Callback function to retrieve information */
  setExtraData: PropTypes.func.isRequired,
}

Report.defaultProps = {
  category: null,
  isGroupActivity: false,
  view: '',
}

export default Report



// WEBPACK FOOTER //
// ./src/Components/Activity/Report.jsx